export default "__VITE_PUBLIC_ASSET__3b94dba1__"